import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { Phones } from './PatientElements';
import { parseAddress, parseName, parsePhones } from '../utils';
export const Physicians = ({
  physicians
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, defaults.physicians), physicians.type ? /*#__PURE__*/React.createElement(Physician, {
  phys: physicians
}) : physicians.map(phys => /*#__PURE__*/React.createElement(Physician, {
  phys: phys,
  key: `${phys.name}-${phys.type}`
})));

const Physician = ({
  phys
}) => {
  const type = String(phys.type).toUpperCase();
  const name = parseName(phys);
  const {
    street,
    city,
    state,
    zip
  } = parseAddress(phys);
  const phones = parsePhones(phys);
  const typeStyle = [styles.FacesheetText, styles.pYPointOneCm, styles.fontWeightBold];
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.width100, styles.justifyContentAround]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: typeStyle
  }, type)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, name)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width20, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, street)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width12point5, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, city)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width10, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, `${state} ${zip}`)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width15, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, phones && /*#__PURE__*/React.createElement(Phones, {
    phones: phones
  }))));
};